import { render, staticRenderFns } from "./ComponentDanMenu.vue?vue&type=template&id=5bfc0459&scoped=true"
import script from "./ComponentDanMenu.vue?vue&type=script&lang=js"
export * from "./ComponentDanMenu.vue?vue&type=script&lang=js"
import style0 from "./ComponentDanMenu.vue?vue&type=style&index=0&id=5bfc0459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc0459",
  null
  
)

export default component.exports